<template>
  <transition name="fade">
    <div v-if="visible" :class="['overlay', status]">
      <div class="content">
        <div class="status-icon">
          <v-icon color="white" size="68">
            {{ status === "in" ? "mdi-check" : "mdi-logout" }}
          </v-icon>
        </div>
        <h1>{{ statusText }}</h1>
        <h2>{{ employeeName }}</h2>
        <p>{{ status === "in" ? "Have a great shift" : "You’re all set" }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ClockStatusOverlay",
  props: {
    visible: Boolean,
    employeeName: String,
    status: String, // 'in' or 'out'
  },
  computed: {
    statusText() {
      return this.status === "in" ? "CLOCKED IN" : "CLOCKED OUT";
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  animation: pop 0.3s ease-out;
}

.overlay.in {
  background: linear-gradient(145deg, rgba(5, 150, 105, 0.97), rgba(22, 101, 52, 0.97));
}

.overlay.out {
  background: linear-gradient(145deg, rgba(239, 68, 68, 0.97), rgba(153, 27, 27, 0.97));
}

.content {
  text-align: center;
}
.status-icon {
  display: inline-flex;
  width: 112px;
  height: 112px;
  margin-bottom: 24px;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.72);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
}

.content h1 {
  font-size: 60px;
  font-weight: bold;
  margin-bottom: 20px;
}

.content h2 {
  font-size: 40px;
  font-weight: 600;
}
.content p {
  margin-top: 12px;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.86);
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes pop {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}
</style>
